<!-- 默认的交易账户申请表单 -->
<template>
  <div class="default-apply-form">
    <div class="card-base card-shadow--small  p-30">
      <confirmInfoForm
        :status="status"
        :tradeAccountType="tradeAccountType"
        :remark="remark"
        @changeComfirmInfo="changeComfirmInfo"/>
      <hr v-if="isShowAgree"/>
      <div class="apply-notice" v-if="isShowAgree">
        <div>
          <defaultArticleContent
          @submitForm="submitForm"
          :status="status"
          />
        </div>
      </div>
      <div class="eddidTips" v-if="isShowTips">
        <p class="font-sx-pf">{{$t('applyTradeAccount.tipsText1')}}</p>
        <p>{{$t('applyTradeAccount.tipsText2')}}</p>
      </div>
      </div>
  </div>
</template>
<script>
import defaultArticleContent from './defaultArticleContent'
import confirmInfoForm from '../confirmInfoForm'
export default {
  components: {
    defaultArticleContent,
    confirmInfoForm
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    tradeAccountType: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowButton: true,
      isShowAgree: false,
      isShowTips: false,
      infoIsSome: false
    }
  },
  methods: {
    submitForm (val) {
      this.$emit('createAccount', { agree: val.agree, infoIsSome: this.infoIsSome, relatedMarginAccounts: val.relatedMarginAccounts })
    },
    changeComfirmInfo (val) {
      this.infoIsSome = val.infoIsSome
      if (this.infoIsSome === 'yes') {
        this.isShowButton = true
        this.isShowAgree = true
        this.isShowTips = false
      } else {
        this.isShowButton = false
        this.isShowAgree = false
        this.isShowTips = true
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.default-apply-form {
  .p-30{
    padding: 0px 30px 30px 30px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .eddidTips {
    font-size: 14px;
    padding: 5px;
  }
  .apply-notice {
    h3 {
      color: rgba(36, 40, 45, 1);
      font-size: 16px;
      font-family: Muli-Bold;
    }
  }
}
</style>
